/* ============
 * Vue Router
 * ============
 *
 * The official Router for Vue.js. It deeply integrates with Vue.js core
 * to make building Single Page Applications with Vue.js a breeze.
 *
 * http://router.vuejs.org/en/index.html
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/routes';
import store from '../store';

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isMainPages = from.name === 'order.unit-list' || from.name === 'order.overview';
  if (isMainPages) {
    store.commit('navigation/setPrevRoute', from.name );
  }
  if ('crop' in to.query) {
    store.commit('units/setCrop', to.query.crop === 'true');
  }

  if (document.documentElement.scrollTop) {
    document.documentElement.scrollTop = 0;
  }

  next();
});
router.afterEach((to, _) => {
  store.commit('service/setRouteParams', to.params);
});

router.beforeEach((to, from, next) => {
  store.dispatch('sunstudy/resetSunstudyMode', { to, from })
    .then(() => next());
});

Vue.router = router;

export default {
  router,
};
